module.exports = __webpack_public_path__ + "static/media/portada.4a7a864b.png";